module.exports = __webpack_public_path__ + "img/e6ea176.png";